export enum BagsAndSeatsEventTypes {
  SELECT_BAGGAGE = "SELECT_BAGGAGE",
  SELECT_SEAT = "SELECT_SEAT",
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
}

export interface SelectBaggage {
  type: BagsAndSeatsEventTypes.SELECT_BAGGAGE;
}

export interface SelectSeat {
  type: BagsAndSeatsEventTypes.SELECT_SEAT;
}

export interface BagsAndSeatsNextEvent {
  type: BagsAndSeatsEventTypes.NEXT;
}

export interface BagsAndSeatsPreviousEvent {
  type: BagsAndSeatsEventTypes.PREVIOUS;
}

export type BagsAndSeatsEvents =
  | SelectBaggage
  | SelectSeat
  | BagsAndSeatsNextEvent
  | BagsAndSeatsPreviousEvent;
